(function() {
  var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
templates['accountCreditsTip.tmpl'] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "	\n			<h4>Credits to spend</h4>		\n			<p>Just find a project to fund, and we'll automatically apply your gift card and account credits at checkout.</p>\n			";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.accountCredits)),stack1 == null || stack1 === false ? stack1 : stack1.expirationDate), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n	";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "<i>Account credits expire on ";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.formatDate || (depth0 && depth0.formatDate)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.accountCredits)),stack1 == null || stack1 === false ? stack1 : stack1.expirationDate), options) : helperMissing.call(depth0, "formatDate", ((stack1 = (depth0 && depth0.accountCredits)),stack1 == null || stack1 === false ? stack1 : stack1.expirationDate), options)))
    + ".</i>";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n		";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.accountCredits), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "	\n		";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.giftCode), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	";
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "	\n			<h4>Account credits to spend</h4>\n			<p>Just find a project to fund, and we'll automatically apply your credits at checkout.</p>\n			";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.accountCredits)),stack1 == null || stack1 === false ? stack1 : stack1.expirationDate), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n		";
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "<i>Expires on ";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.formatDate || (depth0 && depth0.formatDate)),stack1 ? stack1.call(depth0, ((stack1 = (depth0 && depth0.accountCredits)),stack1 == null || stack1 === false ? stack1 : stack1.expirationDate), options) : helperMissing.call(depth0, "formatDate", ((stack1 = (depth0 && depth0.accountCredits)),stack1 == null || stack1 === false ? stack1 : stack1.expirationDate), options)))
    + ".</i>";
  return buffer;
  }

function program8(depth0,data) {
  
  
  return "	\n			<h4>Credits to spend</h4>\n			<p>Just find a project to fund, and we'll automatically apply your gift card credits at checkout.</p>\n		";
  }

  buffer += "<div role=\"button\" tabIndex=0 id=\"account-credits-tip\" class=\"tooltip-wrapper lgreen-background tooltip-redux js-click-on-enter-or-space hide-quick-donate js-account-credits-tip\">\n	<span class=\"js-credit-amount\" aria-label=\"account credits\">";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.formatCurrency || (depth0 && depth0.formatCurrency)),stack1 ? stack1.call(depth0, (depth0 && depth0.totalAvailable), options) : helperMissing.call(depth0, "formatCurrency", (depth0 && depth0.totalAvailable), options)))
    + "</span>\n	<div class=\"hover-tooltip\">\n	";
  options = {hash:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),data:data};
  stack2 = ((stack1 = helpers.compare || (depth0 && depth0.compare)),stack1 ? stack1.call(depth0, (depth0 && depth0.accountCredits), "&&", (depth0 && depth0.giftCode), options) : helperMissing.call(depth0, "compare", (depth0 && depth0.accountCredits), "&&", (depth0 && depth0.giftCode), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "			\n	</div>	\n</div>\n";
  return buffer;
  });
})();